var permisos: (per: string[]) => boolean;
export function setPermisos(p: (per: string[]) => boolean) {
    permisos = p;
}
export function Auth(per: string) {
    return permisos([per]);
}
export function AuthSome(per: string[]) {
    return permisos(per);
}